export default __webpack_public_path__ + "static/media/dashboard-colored.b3b1b4ed.svg";